<template lang="pug">
.acesso-rapido(v-loading='carregando')
    section.acesso-rapido__header.row
        .acesso-rapido__header__title.col-12
            | {{ $t('mensagens.home.acessoRapido.titulo') }}

    section.acesso-rapido__body.row
        .acesso-rapido__body__atalhos.col-12
            Atalho(
                v-for='atalho in atalhoAcessoPermitido',
                :key='atalho.id',
                :atalho='atalho',
                style='margin-right: 16px'
            )
</template>

<script>
import Atalho from '@/components/home/acessoRapido/Atalho';
import AtalhoService from '@/services/AtalhoService';
import { formatFlag } from '@/utils/featureFlags/featureFlag';
import { FeatureFlagConst } from '@/constants/FeatureFlag';
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'AcessoRapido',
    
    components: { Atalho },

    data() {
        return {
            atalhos: [],
            carregando: true,
            fF4390AjustarAcessoRapido: this.$unleash.isEnabled(formatFlag(FeatureFlagConst.FF4390_CADASTRO_TERRITORIO_SISE))
        };
    },

    computed: {
        ...mapState(['usuarioIsLaudo']),
        ...mapGetters(['ambientePy', 'ambienteAr']),
        atalhoAcessoPermitido() {
            if (this.fF4390AjustarAcessoRapido) {
                if (this.ambientePY || this.ambienteAr) {
                    const nomesExibir = [
                        'Cadastrar Pessoa',
                        'Cadastrar Território',
                        'Diagnóstico Socioambiental',
                        'Monitoramento Socioambiental'
                    ];

                    return this.atalhos.filter(atalho => nomesExibir.includes(atalho.nome));
                }
            }

            return this.atalhos;
        }
    },

    async mounted() {
        await this.buscarAtalhos();
    },

    methods: {
        async buscarAtalhos() {
            this.carregando = true;
            try {
                const { data } = await AtalhoService.buscarAtalhos();
                this.atalhos = data.atalhos;
            } catch {
                this.$notify.error({ message: this.$t('mensagens.home.acessoRapido.erro') });
            } finally {
                this.carregando = false;
            }
        }
    }
};
</script>

<style scoped lang="scss">
.acesso-rapido {
    margin: 0;

    .acesso-rapido__header {
        margin: 0;

        .acesso-rapido__header__title {
            font-size: 16px;
            font-weight: 700;
            margin-bottom: 3px;
            padding: 0;
        }
    }

    .acesso-rapido__body {
        height: 110px;
        margin: 0;

        .acesso-rapido__body__atalhos {
            height: 110px;
            padding: 0;
            display: flex;
            overflow-x: auto;
        }
    }
}
</style>
